
import { dsSetBaseSize } from 'static/js/functions'
import { Component, Vue } from 'nuxt-property-decorator';

@Component({
  name: 'LoadingCircle',
})
export default class LoadingCircle extends Vue {
  
  loading: boolean = false
  op: number = 1

  start() {
    this.op = 1
    this.loading = true
  }

  finish() {
    // 通常のサイクルでloadingは解除しない
  }

  /**
   * 手動でローディング画面を解除する
   * 
   * @param duration 解除アニメーションの時間（msec）
   */
  manualFinish(duration: number = 200) {
    dsSetBaseSize()
    const handle = setInterval(() => {
      this.op = this.op - 0.01
      if(this.op <= 0) {
        clearInterval(handle)
        this.op = 0
        this.loading = false
      }
    }, duration / 100)
  }
}
